export default "__VITE_ASSET__976f35b8__"